import { makeStyles } from '@material-ui/core/styles';
import { designTokens } from '../../styles/designTokens';

export const useStyles = makeStyles({
    headerWrapper: {
        padding: `${designTokens.spacing.xl} ${designTokens.spacing.lg} ${designTokens.spacing.lg}`,
        '@media (max-width: 640px)': {
            padding: `${designTokens.spacing.md} ${designTokens.spacing.sm} ${designTokens.spacing.sm}`,
        },
        '@media (max-width: 600px)': {
            paddingBottom: '0',
        },
    },
    pageHeader: {
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
    },
    headerRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: designTokens.spacing.lg,
        gap: designTokens.spacing.lg,
        '@media (max-width: 900px)': {
            flexDirection: 'column',
            alignItems: 'stretch',
        },
        '@media (max-width: 600px)': {
            marginBottom: designTokens.spacing.md,
            gap: designTokens.spacing.md,
        }
    },
    headerLeft: {
        display: 'flex',
        flexDirection: 'column',
        gap: designTokens.spacing.xs,
    },
    pageTitle: {
        ...designTokens.typography.h1,
        margin: 0,
    },
    pageSubtitle: {
        ...designTokens.typography.subtitle,
        margin: 0,
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
    searchInputWrapper: {
        minWidth: '380px',
        '@media (max-width: 900px)': {
            minWidth: 'auto',
            width: '100%',
        }
    },
    controlsRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: designTokens.spacing.lg,
        alignItems: 'center',
        '@media (max-width: 900px)': {
            flexDirection: 'column',
            alignItems: 'stretch',
            marginBottom: designTokens.spacing.md,
        }
    },
    dateRangePickerWrapper: {
        width: '250px',
        '@media (max-width: 900px)': {
            width: '100%',
        }
    },
    buttonWrapper: {
        width: '300px',
        '@media (max-width: 900px)': {
            width: '100%',
        }
    },
    iconButtonWrapper: {
        marginLeft: 'auto',
        flexShrink: 0,
        '@media (max-width: 900px)': {
            marginLeft: 0,
            alignSelf: 'flex-end',
        }
    },
    iconButton: {
        padding: '8px',
        backgroundColor: designTokens.colors.primary,
        color: designTokens.colors.text.white,
        borderRadius: designTokens.borderRadius.button,
        '&:hover': {
            backgroundColor: designTokens.colors.primaryDark,
        },
        '&:disabled': {
            backgroundColor: designTokens.colors.primaryLight,
            color: designTokens.colors.text.white,
        },
        '& svg': {
            width: '20px',
            height: '20px',
        },
    },
});
